import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Custom element to display nutrition info that updates on variant change.
 */
export default class ProductNutritionInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const sectionOrDialog = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    if (sectionOrDialog) {
      sectionOrDialog.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    } else {
      document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const sectionOrDialog = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    if (sectionOrDialog) {
      sectionOrDialog.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    } else {
      document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    }
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        const selector = blockId
          ? `product-nutrition-info[data-block-id="${blockId}"] .nutrition-text-content`
          : `product-nutrition-info .nutrition-text-content`;

        const newContent = html.querySelector(selector);
        const currentContent = this.querySelector('.nutrition-text-content');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-nutrition-info] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-nutrition-info')) {
  customElements.define('product-nutrition-info', ProductNutritionInfo);
}
